module.exports = __webpack_public_path__ + "img/d2.ca0253a4.png";